import { useOktaAuth as useOktaAuthBase } from '@okta/okta-react'
import { isEmpty } from 'lodash-es'
import { useCallback, useEffect } from 'react'
import { clearLocalStorage, setStoredAuthToken } from './authUtils'
import { Auth } from './useAuth'

export function useOktaAuth(): Auth {
  const okta = useOktaAuthBase()
  const { authState, oktaAuth } = okta || {}
  const isAuthenticated = !isEmpty(authState) && authState.isAuthenticated

  useEffect(() => {
    const { accessToken } = authState?.accessToken || {}
    if (isAuthenticated && accessToken) {
      // Store token in localStorage (Okta pattern) - no Redux needed
      setStoredAuthToken(accessToken)
    }
  }, [isAuthenticated, authState])

  const logout = useCallback(async () => {
    // Clear NPS survey timestamps on logout
    localStorage.removeItem('nps_login_timestamp')
    localStorage.removeItem('nps_dismiss_timestamp')

    await oktaAuth.signOut()
    clearLocalStorage()
  }, [oktaAuth])

  const loginRedirect = useCallback(async () => {
    if (!authState) return // Wait for authState to resolve
    if (!authState.isAuthenticated) {
      // Initiate login if not authenticated
      await oktaAuth.signInWithRedirect({ originalUri: '/' })
    }
  }, [authState, oktaAuth])

  return {
    logout,
    isAuthenticated,
    loginRedirect,
    instance: oktaAuth,
    authState,
  }
}
